import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Button, CheckBox, Table, TextInput} from "../../../components";
import {manualRoutingAction, subscriptionRoutingAction} from "redux/actions";
import {internalSearch} from "helper";
import DynamicPageTable from "../../../components/Table/DynamicPageTable";

const initialState = {
    sp_id: "",
    first_name: "",
    mobile: ""
};

const FinterSP = (searchFrom, searchBy, searchIn) =>{
    if (!searchFrom?.[searchBy] || !searchIn?.length || !searchBy)
        return searchIn;

    // Check if the searching values are not a number
    if (
        isNaN(parseInt(searchIn?.[0]?.[searchBy])) &&
        isNaN(parseInt(searchFrom?.[searchBy]))
    ) {
        const filteredRows =
            searchIn?.length &&
            searchIn.filter(
                (item) =>
                    item[searchBy]?.toString()?.toLowerCase().includes(searchFrom?.[searchBy]?.toLowerCase())
            );

        return filteredRows;
    } else {
        const filteredRows =
            searchIn?.length &&
            searchIn.filter(
                (item) =>
                    item[searchBy]?.toString().indexOf(searchFrom?.[searchBy]) !== -1
            );

        return filteredRows;
    }
}

function ManualRouting({clickedSubscription}) {
    const id = clickedSubscription.id

    // Redux
    const dispatch = useDispatch();
    const {manualRouting} = useSelector(state => state);

    const [tableRows, setTableRows] = useState();
    
    const [spIDs, setSpIDs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    

    // Filter States
    const [filterState, setfilterState] = useState(initialState);
    const onChange = e =>
        setfilterState({...filterState, [e.target.name]: e.target.value});

    useEffect(() => {
        dispatch(manualRoutingAction.get(id));
    }, [dispatch]);

    useEffect(() => {
        let filtered = manualRouting;
        
        if (!filtered?.length) {
            setTableRows();
            return;
        }

        filtered = FinterSP(filterState, "sp_id", filtered);
        filtered = FinterSP(filterState, "first_name", filtered);
        filtered = FinterSP(filterState, "mobile", filtered);

        // Map table rows
        filtered = filtered?.map(obj => {
            return {
                select: (
                    <CheckBox
                        marginRight={0}
                        marginTop={0}
                        checked={spIDs?.find(id => id == obj?.sp_id) ? true : false}
                        onChange={e =>
                            setSpIDs(prev => {
                                const arr = prev;
                                if (e.target.checked) arr.push(obj?.sp_id);
                                else arr.splice(arr.indexOf(obj?.sp_id), 1);

                                return [...arr];
                            })
                        }
                    />
                ),
                sp_id: obj?.sp_id,
                sp_name: obj?.first_name + " " + obj?.last_name,
                mobile: obj?.country_code + obj?.mobile,
                role: obj?.role,
                org_id: obj?.org_name,
                sub_org_id: obj?.sub_org_name,
                location: obj?.location,
                city_id: obj?.city_name,
                s2_c: obj?.s2_c,
                c2_s: obj?.c2_s,
                s2_vc: obj?.s2_vc,
                s2_c2_c: obj?.s2_c2_c,
                enabled: obj?.enabled,
                updated_at: `${new Date(obj?.updated_at).toLocaleString()}`
            };
        });

        setTableRows(filtered);
    }, [spIDs, manualRouting, filterState]);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: (
                    <CheckBox
                        marginRight={0}
                        marginTop={0}
                        checked={
                            manualRouting?.length && manualRouting?.length === spIDs?.length
                        }
                        onChange={e => {
                            if (e.target.checked)
                                setSpIDs(manualRouting?.map(obj => obj?.sp_id));
                            else setSpIDs([]);
                        }}
                    />
                )
            },
            {title: "Provider"},
            {title: "SP Name"},
            {title: "Mobile"},
            {title: "Role"},
            {title: "Org"},
            {title: "Sub Org"},
            {title: "Location"},
            {title: "City"},
            {title: "s2_c"},
            {title: "c2_s"},
            {title: "s2_vc"},
            {title: "s2_c2_c"},
            {title: "Enabled"},
            {
                title: "Updated",
                sortBy: "updatedAt"
            }
        ],
        [tableRows]
    );
    // @@@@@@@@
    return (
        <>
            
            <TextInput
                search
                label="Filter By Provider"
                name="sp_id"
                onChange={onChange}
                style={{width: 100}}
                value={filterState?.sp_id}
            />
            <TextInput
                search
                label="Filter By SP First Name"
                name="first_name"
                onChange={onChange}
                style={{width: 200}}
                value={filterState?.first_name}
            />
            <TextInput
                search
                label="Filter By SP Mobile"
                name="mobile"
                onChange={onChange}
                style={{width: 200}}
                value={filterState?.mobile}
            />
            <Button
                title="Send Routes"
                style={{marginTop: 27}}
                onClick={
                    spIDs?.length
                        ? () =>
                            dispatch(
                                subscriptionRoutingAction.post({
                                    subscription_id: id,
                                    sp_ids: spIDs
                                })
                            )
                        : null
                }
            />
           &nbsp;&nbsp;&nbsp;&nbsp; <span style={{color:"green"}}>{clickedSubscription.mrmsg}</span>
            <DynamicPageTable headers={tableHeaders} data={tableRows}/>
            
        </>
    );
}

export default ManualRouting;